import { useCarrierDeliveryProposalCreatePageProps } from "./fetch";
import { CarrierDeliveryProposalCreatePageUi } from "./ui";

export const CarrierDeliveryProposalCreatePage: React.FC<{
  offerCargoIdStr: string | undefined;
}> = (params) => {
  const props = useCarrierDeliveryProposalCreatePageProps(
    params.offerCargoIdStr,
  );
  return <CarrierDeliveryProposalCreatePageUi {...props} />;
};
